/**
 * Workspace API — layout document, bootstrap, tree mutation.
 *
 * `/v2/workspace/{scope}/…` only. Chart assets (drawings, templates,
 * chart settings profiles) live in `features/charts/chart-assets-api.ts`.
 *
 * Every consumer is a one-liner over `usersClient`. Auth + 401-refresh are
 * shared session-wide via `services/api/api-client.ts`.
 */

import { usersClient } from '@/services/api/api-client'
import { recordDump } from '@/services/api/save-dump'
import type { BootstrapData, MutateTreeOp, MutateTreeResult } from './types'

function workspacePath(scope: string): string {
  return `/v2/workspace/${scope}`
}

// ─── Bootstrap / tree mutation ───

export async function bootstrap(scope: string): Promise<BootstrapData> {
  return usersClient.get<BootstrapData>(`${workspacePath(scope)}/bootstrap`)
}

export async function mutateTree(
  scope: string,
  operations: MutateTreeOp[],
  opts?: { revisioned?: boolean },
): Promise<MutateTreeResult> {
  recordDump(scope, 'mutateTree', `${workspacePath(scope)}/mutate`, {
    operations,
    revisioned: opts?.revisioned ?? true,
  })
  return usersClient.post<MutateTreeResult>(`${workspacePath(scope)}/mutate`, {
    operations,
    revisioned: opts?.revisioned ?? true,
  })
}
